import React, { useAuth, useState, useRef, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';
import { ManagerContext } from '../contexts/ManagerContext';
import validator from 'validator';
import LockOpen from '@mui/icons-material/LockOpen';
import ResetPasswordDialog from '../components/AuthUI/ResetPasswordDialog';
import Login from '../components/Auth/login';
import { updateCurrentUser } from 'firebase/auth';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    textAlign: 'center',
}));




const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};




export default function ResetPassword () {
    const { token } = useParams(); // zakładając, że masz token w URL
    const { currentUser, sendAuth, connectionState, setOpenBackDrop } = React.useContext(ManagerContext);
    const [ openSendEmail, setOpenSendEmail ] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [password, setPassword] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [emailError, setEmailError] = React.useState('');
    const [nickName, setNickName] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [passwordError, setPasswordError] = React.useState([]);
    const [showPassword, setShowPassword] = React.useState(false);
    const [emailConfirm, setEmailConfirm ] = React.useState(0);
    const inputRef = React.useRef(null);
    const [waitResponse, setWaitResponse] = React.useState(false);
        
   useEffect(() => {
        const datas = { task: "token_login", data: {token} }
        setOpenBackDrop(true);
        const inter = setInterval(() => {
            console.log(connectionState)
            if (connectionState === "OPEN"){
                clearInterval(inter);
                handleSendAuth(datas);
            }
        }, 1000)
        
        return () => {
            clearInterval(inter);
        };
    }, [connectionState]);

    const handleSendAuth = async (datas) => {

        console.log('handleSendAuth', datas);
        const map = new Map()
        map.set("data", datas.data)
        map.set("task", datas.task)
        setWaitResponse(true)
        const response = await sendAuth(map);
        setWaitResponse(false)
        
        console.log('response', response);
        if (response.token_login_status === 1){
            console.log('dddddddddddddddd');
            setEmail(response.currentUser.email)
            setOpenBackDrop(false);
            setOpen(true)
        }else{
            setOpenBackDrop(false);
            setOpenSendEmail(true);
            // return <ResetPasswordDialog />
        }
        

    }
    
    React.useEffect(() => {
        console.log("Token do zresetowania hasła: ", token);
        // Możesz tutaj użyć tokena do odczytania danych lub do dalszej logiki...
    }, [token]);
    
    
    




    const changeEmail = (value) => {
        setEmail(value)
        setPassword('')
        setNickName('')
        setPhoneNumber('')
        setPasswordError([])
        setShowPassword(false)
        setEmailConfirm(0)
        if (!validator.isEmail(value)) {
            setEmailError('The email is invalid.');
        } else {
            setEmailError('');
        }
    }
    const validate = (value) => {
        console.log('validation');
        setPassword(value);

        let errors = [];

        // Walidacja minimum znaków
        if (value.length < 8) {
            errors.push('At least 8 characters.');
        }
        // Walidacja minimum małych liter
        if (!/[a-z]/.test(value)) {
            errors.push('At least one lowercase letter.');
        }
        // Walidacja minimum wielkich liter
        if (!/[A-Z]/.test(value)) {
            errors.push('At least one uppercase letter.');
        }
        // Walidacja minimum cyfr
        if (!/[0-9]/.test(value)) {
            errors.push('At least one number.');
        }

        // Ustaw komunikaty błędów
        setPasswordError(errors); // Ustaw na tablicę z komunikatami błędów
    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <div style={{ alignSelf: 'center'}}>
            <Login btVisible={false} _open={open} _setOpen={setOpen} authType={3} _email={email}/>
            <ResetPasswordDialog messageType={1} btVisible={false} _open={openSendEmail} />

            {/* <ResetPasswordDialog _open={openSendEmail}/> */}
            {/* <Modal
                open={false}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1302, borderRadius: '10px' }}
                helperText={emailError}
                
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{textAlign: 'center'}}>
                        {emailConfirm !== 2? 'Login': 'Register'}
                    </Typography>
                    <form onSubmit={(e) => { 
                        e.preventDefault(); // Zapobiega domyślnemu zachowaniu formularza
                        console.log('confirm', emailConfirm)
                        if (emailConfirm === 0){
                            const data = { email: email }
                            const datas = { task: 'email_status', data: data }
                            sendTask(datas); // Przechodzi do kolejnego kroku
                        }else if (emailConfirm === 1){
                            if (email.trim() && password.trim()){
                                const data = {  email: email, password: password }
                                const datas = { task: 'login', data: data }
                                sendTask(datas); // Przechodzi do kolejnego kroku
                            }
                        }else if (emailConfirm === 2){ 
                            if (email.trim() && password.trim() && nickName.trim()){
                                const data = { email: email, password: password, nick_name: nickName, phone_number: phoneNumber }
                                const datas = { task: 'register', data: data }
                                sendTask(datas); // Przechodzi do kolejnego kroku
                            }
                        }
                    }} style={{ margin: 1, width: '35ch',     textAlign: 'center' }}>

                        <TextField
                            required
                            id="outlined-email"
                            label="email"
                            type='email'
                            error={!!emailError}
                            helperText={emailError}
                            sx={{ marginTop: '10px', width: '100%' }}
                            autoFocus
                            value={email}
                            onChange={(e) => changeEmail(e.target.value)}
                            // onKeyPress={(e) => {
                            //     if (e.key === 'Enter') {
                            //         e.preventDefault(); // Zapobiega wysłaniu formularza po Enter
                            //         setEmailConfirm(1); // Alternatywnie możesz ustawić wartość, aby przejść do następnego pola
                            //     }
                            // }}
                        />
                        
                        {emailConfirm !== 0 && <FormControl variant="outlined" required autoComplete="current-password" error={passwordError.length > 0} sx={{ marginTop: '10px', width: '100%' }}>
                            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                autoComplete="current-password"
                                onChange={(e) => validate(e.target.value)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={showPassword ? 'hide password' : 'show password'}
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Password"
                            />
                            {passwordError.length > 0 && (
                                <Typography component="div" color="error">
                                    {passwordError.map((error, index) => (
                                        <div key={index}>{error}</div>
                                    ))}
                                </Typography>
                            )}
                        <Typography component="div" color="white" sx={{mt:1, textAlign: 'end'}}
                        onClick={() =>console.log('forgot password')}>
                            
                        </Typography>
                        </FormControl>
                        
                        }

                        <LoadingButton 
                            variant="contained"
                            sx={{ marginTop: '30px' }}
                            type='submit'
                            loading={waitResponse}
                            loadingPosition="end" 
                        >
                            {emailConfirm === 0? 'Next': emailConfirm === 1? 'Login': 'Register'}
                        </LoadingButton>
                    </form>
                </Box>
            </Modal> */}
        </div>
    );
}